/** WebRTC ICE servers (STUN/TURN). Empty = host candidates only, aligned with mobile. */
export const ICE_SERVERS: RTCIceServer[] = [];
/** Janus plugin name for VideoRoom attach */
export const VIDEOROOM_PLUGIN = 'janus.plugin.videoroom';
/** Debounce rapid `devicechange` events (plug/unplug headsets) */
export const DEVICE_CHANGE_DEBOUNCE_MS = 400;
/** Base delay before the first WebSocket reconnect attempt */
export const WS_RECONNECT_BASE_MS = 1000;
/** Maximum backoff delay between WebSocket reconnect attempts */
export const WS_RECONNECT_MAX_DELAY_MS = 30_000;
/** Stop scheduling WebSocket reconnect after this many attempts */
export const WS_RECONNECT_MAX_ATTEMPTS = 10;
/** Janus session keepalive interval */
export const KEEPALIVE_INTERVAL_MS = 30_000;
/** Max wait for publisher join + SDP before failing `joinRoom` */
export const JOIN_ROOM_TIMEOUT_MS = 20_000;
/** Wait before tearing down subscriber PC after ICE disconnect */
export const SUBSCRIBER_ICE_RECOVERY_MS = 3500;
/** Poll interval while waiting for `navigator.onLine` during reconnect */
export const NETWORK_ONLINE_POLL_MS = 2000;
/** After network drop: window for devicechange/permission-driven full reconnect */
export const NETWORK_BLIP_RECONNECT_MS = 60_000;
/** Coalesce burst reconnect requests (permission/network) into one run */
export const RECONNECT_DEBOUNCE_MS = 450;
/** Debounce `recoverLocalAudio` / republish when re-enabling mic+sound */
export const RECOVER_LOCAL_AUDIO_DEBOUNCE_MS = 2500;
/** Grace period while offline before ending the call (15s) */
export const NETWORK_RECONNECT_TIMEOUT_MS = 15000;
/** SDP offer options when publishing audio-only to VideoRoom */
export const PUBLISHER_OFFER_OPTIONS: RTCOfferOptions = {
  offerToReceiveAudio: true,
  offerToReceiveVideo: false,
};
